import { useEffect } from "react";
import { useLocation } from "react-router";

export function useScrollToHash<T extends unknown[]>(deps: T) {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash.replace('#', '');
    if (hash) {
      const element = document.getElementById(hash);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
    
  }, [location.hash, ...deps]);
}